<template>
    <v-container>
      <v-layout row wrap>
        <v-flex sm12 md12 lg3>
          <router-link to="/importMaster/train-master">
            <v-card
                class="mx-auto"
                max-width="340">
              <div style="margin: 10px 63px">
              <v-img
                  :src="storage_path()+'local.png'"
                  height="100px" width="100px" style="align-content: center"></v-img></div>
<!--              <v-span name="local" style="font-size: 200%;margin:20px;color:#A52A2A;"></v-span>-->
              <v-card-title>
                <v-icon color="#bbbbc6" class="black--text mr-2">train
                </v-icon>
                Import Train Master
              </v-card-title>
            </v-card>
          </router-link>
        </v-flex>
        <v-flex sm12 md12 lg1></v-flex>
        <v-flex sm12 md12 lg3>
          <router-link to="/importMaster/metro-master">
            <v-card
                class="mx-auto"
                max-width="340"

            >
              <div style="margin: 10px 63px">
             <v-img
                   :src="storage_path()+'metro.png'"
                   height="100px" width="100px" style="align-content: center"></v-img></div>
<!--              <v-span name="metro" style="font-size: 100%;margin:20px;color:#6495ED;"></v-span>-->
              <v-card-title>
                <v-icon color="#bbbbc6" class="black--text mr-2">tram</v-icon>
                Import Metro master
              </v-card-title>
            </v-card>
          </router-link>
        </v-flex>

        <v-flex sm12 md12 lg1></v-flex>
        <v-flex sm12 md12 lg3>
          <router-link to='/importMaster/mono-master'>
            <v-card
                class="mx-auto"
                max-width="340">
                  <div style="margin: 10px 63px">
                    <v-img
                        :src="storage_path()+'mono.png'"
                        height="100px" width="100px" style="align-content: center"
                    ></v-img>
                  </div>

<!--             <v-span name="mono" style="font-size: 200%;margin:20px;color:#006400;"></v-span>-->
              <v-card-title>
                <v-icon color="#bbbbc6" class="black--text mr-2">subway
                </v-icon
                >
                Import Mono Master

              </v-card-title>
            </v-card>
          </router-link>
        </v-flex>
        <v-flex sm12 md12 lg1></v-flex>

      </v-layout>
    </v-container>
</template>

<script>
export default {
}
</script>

<style scoped>

</style>
